module.exports = __webpack_public_path__ + "img/cert1.784c33b1.png";